import { Presenter } from '@d-id/types';
import { useEffect } from 'react';

import { toast } from '@/components/toast';
import { logger } from '@/services/logger';
import { NotificationTopics, useNotifications } from '@/services/notification/notificationProvider';
import { GET_PRESENTERS_KEY } from '@/state/presenters';
import { useQueryClient } from 'react-query';

enum PremiumPlusNotificationStatus {
    Rejected = 'rejected',
    Created = 'created',
    Started = 'started',
    Progress = 'progress',
    Error = 'error',
    Done = 'done',
    PostDone = 'post-done',
}

export const useCreatePremiumPlusNotifications = () => {
    const { subscribe, unsubscribe } = useNotifications();
    const queryClient = useQueryClient();

    useEffect(() => {
        const subscriptionId = subscribe(NotificationTopics.premiumPlusTrain, async (event: MessageEvent) => {
            try {
                console.debug('Premium Plus notification received', event.data);
                const parsedMessage = JSON.parse(event.data);
                const subject = parsedMessage.messageAttributes.subject.stringValue;
                const status = subject?.split('/')?.[1];

                if (!Object.values(PremiumPlusNotificationStatus).includes(status)) {
                    // Ignore unknown status
                    return;
                }

                queryClient.invalidateQueries([GET_PRESENTERS_KEY]);

                if (status === PremiumPlusNotificationStatus.PostDone) {
                    const { presenter } = parsedMessage.body as { presenter: Presenter };
                    if (presenter.voice) {
                        toast.success({ title: 'Your Premium+ Avatar was created successfully!' });
                    } else {
                        toast.error({
                            title: 'Your Premium+ Avatar was created successfully, but we had an issue with cloning your voice',
                        });
                    }
                } else if ([PremiumPlusNotificationStatus.Error, PremiumPlusNotificationStatus.Rejected].includes(status)) {
                    toast.error({ title: 'Failed to create your Premium+ Avatar', toastId: 'avatar-create' });
                }
            } catch (error) {
                logger.error('Failed to handle premium plus notification', error);
            }
        });

        return () => {
            unsubscribe(NotificationTopics.premiumPlusTrain, subscriptionId);
        };
    }, []);
};
